import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth, homeFor } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/AuthPages";
import PaymentResult from "@/pages/PaymentResult";
import BusinessApp from "@/pages/biz/BusinessApp";
import RenterApp from "@/pages/renter/RenterApp";
import AdminApp from "@/pages/admin/AdminApp";
import LandlordApp from "@/pages/landlord/LandlordApp";
import { PropertySearch, PropertyPage, AgentPage } from "@/pages/PublicListings";
import { Loading } from "@/components/common";
import { SiteMeta } from "@/components/SiteMeta";

function RequireRole({ role, children }) {
  const { session } = useAuth();
  if (session === null) return <Loading full />;
  if (!session) return <Navigate to="/login" replace />;
  if (session.user.role !== role) return <Navigate to={homeFor(session.user.role)} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <SiteMeta />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment/:result" element={<PaymentResult />} />
          <Route path="/app/*" element={<RequireRole role="business"><BusinessApp /></RequireRole>} />
          <Route path="/portal/*" element={<RequireRole role="renter"><RenterApp /></RequireRole>} />
          <Route path="/landlord/*" element={<RequireRole role="landlord"><LandlordApp /></RequireRole>} />
          <Route path="/properties" element={<PropertySearch />} />
          <Route path="/properties/:id" element={<PropertyPage />} />
          <Route path="/agents/:id" element={<AgentPage />} />
          <Route path="/admin/*" element={<RequireRole role="super_admin"><AdminApp /></RequireRole>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
